export const TYPE_ALL = 'ALL';

export const SYSTEM_TAG_KEYWORDS = 'KEYWORDS';
export const SYSTEM_TAG_PEOPLE = 'PEOPLE';
export const SYSTEM_TAG_BRANDS = 'BRANDS';
export const SYSTEM_TAG_CC = 'CC';
export const SYSTEM_TAG_TEXT = 'TEXT';
export const SYSTEM_TAG_BRAND_SAFETY = 'BRAND_SAFETY';
export const SYSTEM_TAG_IAB = 'IAB';

export const CUSTOM_TAG = 'LABEL';
export const CUSTOM_TAG_NAME = 'LABEL_NAME';
export const CUSTOM_TAG_VALUE = 'LABEL_VALUE';

export const TYPE_DESCRIBE_TITLE = 'TITLE';
export const TYPE_DESCRIBE_PLOT = 'PLOT';

export const AVAILABLE_DEEP_SEARCH_TAGS = [
  SYSTEM_TAG_PEOPLE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_CC,
  SYSTEM_TAG_TEXT,
  CUSTOM_TAG_VALUE,
] as const;

export const AVAILABLE_CHIP_TAGS = [
  CUSTOM_TAG_NAME,
  CUSTOM_TAG_VALUE,
  SYSTEM_TAG_PEOPLE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_IAB,
  SYSTEM_TAG_KEYWORDS,
] as const;
